import SchoolIcon from "@mui/icons-material/School";
import { GraduationServicePath, PLANS } from "utils/constants";
import permissions from "app/permissions";
import ListInternshipPlans from "./List";
import CreateInternshipPlans from "./Create";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: GraduationServicePath + PLANS,
  title: "Стажантски планове",
  list: <ListInternshipPlans />,
  create: <CreateInternshipPlans />,
  permission: permissions.canPreviewInternshipPlans,
};
